import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { UploadCvsModal } from 'modules/ats/components/UploadCvsModal'
import { UploadCvsWidget, useCvBulkUpload } from 'modules/ats/components/UploadCvsWidget'
import { isCvBulkUploadCompleted } from 'modules/ats/lib/utils/cvBulkUpload'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CandidatesDataCollection } from './Table'

const CandidatesPage = () => {
  const { navigation } = useNavigation()
  const [showUploadCvsModal, setShowUploadCvsModal] = useState(false)

  useEffect(() => {
    track(trackingEvents.ats.newCandidatesPageView)
  }, [])

  const { cvBulkUpload, loading: loadingCvBulkUpload } = useCvBulkUpload()

  return (
    <ResponsivePage.Body
      error={null}
      loading={loadingCvBulkUpload}
      variant="full"
      actions={{
        primary: [
          {
            to: navigation.settings.ats.fullPath(),
            icon: 'settings',
            variant: 'secondary',
            label: i18n.t('common.settings'),
          } as const,
        ],
      }}
      showHeader
      header={{
        title: i18n.t('ats.candidates.title'),
        illustration: 'user-search',
      }}
    >
      {!!cvBulkUpload && (
        <Box paddingBottom="s24">
          <UploadCvsWidget cvBulkUpload={cvBulkUpload} />
        </Box>
      )}

      <CandidatesDataCollection
        showUploadCvsButton={!cvBulkUpload || isCvBulkUploadCompleted(cvBulkUpload?.status)}
      />

      <Outlet />
      {showUploadCvsModal && <UploadCvsModal onClose={() => setShowUploadCvsModal(false)} />}
    </ResponsivePage.Body>
  )
}

export default CandidatesPage
